import React, { useEffect, useState } from 'react';
import { Fab } from 'components';
import includeMe from 'utilities/script';
import { IFab } from '../../components/Fab';
import Send from '../../components/Icons/Send';
import { IPageConfigProcessed, WidgetUtils } from '../../utilities/widgetUtils';
import { CookieUtils } from '../../utilities/cookie';
import { COOKIE_VALUES, EVENT_NAME } from '../../utilities/variables';
import {
  IRedirectWidgetCustomisation,
  WidgetSchema,
} from '@bikdotai/bik-models/dm';

export interface ISingleButtonRedirection extends WidgetSchema {
  environment: string;
  id: string;
  storeWidgetConfig: IPageConfigProcessed;
  preview?: boolean;
  isMobile?: boolean;
}

const SingleButtonRedirection = (props: ISingleButtonRedirection) => {
  const widgetUtils = new WidgetUtils();
  const cookieUtils = new CookieUtils();
  const environment = props.environment;
  const widgetId = props.id;
  const widgetCustomisation =
    props.widgetCustomisation as IRedirectWidgetCustomisation;
  const [showFab, setShowFab] = useState(false);
  const [showWidget, setShowWidget] = useState(false);
  let buttonStyle: React.CSSProperties;

  if (widgetCustomisation?.fabText) {
    buttonStyle = {
      width: 'fit-content',
      height: 'fit-content',
      borderRadius: 20,
    };
  }

  cookieUtils.addItemInLocalStorage('storeId', props.info?.storeId);

  cookieUtils.cookieClickHandler(
    `bik-${props.id}-visitor`,
    COOKIE_VALUES.BIK_VISITOR,
    EVENT_NAME.WIDGET_VISITED,
    1,
    props.environment,
    props.id,
  );

  useEffect(() => {
    if (!props.preview) {
      const shouldShow = widgetUtils.showWidget(
        {
          currentUrl: window.location.href.replace(window.location.origin, ''),
          customUrls: props.storeWidgetConfig,
          currentWidgetId: props.id,
        },
        props.info.isAutomationTesting,
      );
      setShowFab(shouldShow);
      setShowWidget(shouldShow);
    } else {
      setShowFab(true);
    }
  }, [window.location.href]);

  const fabStyle: IFab = {
    icon: <Send color={widgetCustomisation?.iconColor} />,
    onClick() {
      cookieUtils.cookieClickHandler(
        `bik-${props.id}-clicked`,
        'bikclick',
        'WIDGET_CLICKED',
        1,
        props.environment,
        props.id,
      );
      const pathName = location.href.replace(location.origin, '');
      //temp feat for liv-space. need to make it generic.
      const isMobileApp = window.navigator.userAgent.includes('livspace-app');
      window.open(
        `${environment}/publicApiFunctions-redirectToChat/?contextType=bik-widgets&contextId=${widgetId}&pathname=${encodeURIComponent(pathName)}&sourceUrl=${location.href}&platform=${isMobileApp ? 'app' : 'web'}`,
      );
    },
    buttonStyle: buttonStyle,
    isMobile: props.isMobile,
    preview: props.preview ?? false,
    widgetCustomisation: {
      fabText: widgetCustomisation?.fabText,
      iconColor: widgetCustomisation?.iconColor,
      fabTransform: widgetCustomisation?.fabTransform,
      fabPositioner: widgetCustomisation?.fabPositioner,
      fabBackgroundColor: widgetCustomisation?.fabBackgroundColor,
      fabLottie: widgetCustomisation?.fabLottie,
      fabAnimationRun: widgetCustomisation?.fabAnimationRun,
      fabImage: widgetCustomisation?.fabImage,
      fabIconLink: widgetCustomisation?.fabIconLink,
      fabWebSize: widgetCustomisation?.fabWebSize,
      fabMobileSize: widgetCustomisation?.fabMobileSize,
      multiLingualConfigurations:
        widgetCustomisation?.multiLingualConfigurations,
    } as IRedirectWidgetCustomisation,
  } as IFab;
  return (
    <>
      {showWidget && (
        <div id={`bik-widget-root-${props.id}`}>
          {showFab && <Fab {...fabStyle} id={`bik-wa-${props.id}-cta`} />}
        </div>
      )}
    </>
  );
};

export default SingleButtonRedirection;

if (process.env.NODE_ENV !== 'development') {
  includeMe(SingleButtonRedirection);
}
